/*
* 组织信息管理组件
* zxw
* 创建时间：
* 修改时间：2026-08-13
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    theme,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import Entity from './OrgInfoEntity';
import AccreditEntity from './OrgAccreditEntity';

const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[0].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh } = props;

    const {
        token: {
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const [record, setRecord] = useState(null);
    const [accreditOpen, setAccreditOpen] = useState(false);

    const handleAccreditOpenOpen = useCallback((value) => {
        setAccreditOpen(value);
    }, []);

    /**
     * 显示权限设置弹框
     */
    const showAccredit = useCallback((record) => {
        setRecord(record);
        setAccreditOpen(true);
    }, [])

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.ACCREDIT:
                showAccredit(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.name, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update, showAccredit]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_accredit') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );


    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '前缀', dataIndex: 'prefix', key: 'prefix', },
        { title: '名称', dataIndex: 'name', key: 'name', },
        { title: '地址', dataIndex: 'address', key: 'address', },
        {
            title: '状态', key: 'status', width: CNF.tableStatusColumnWidth,
            render: (record) => CNF.status.find(item => item.value === record.status)?.key
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', fixed: 'right', width: CNF.tableCreateTimeColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right', hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {record && <AccreditEntity
                record={record}
                open={accreditOpen}
                setOpen={handleAccreditOpenOpen}
                refresh={refresh}
            />
            }
        </>
    );
}

const OrgInfo = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [prefix, setPrefix] = useState('');
    const [name, setName] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handlePrefixChange = useCallback((e) => {
        setPrefix(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            prefix,
            name,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, prefix, name]);

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    onChange={handlePrefixChange}
                    placeholder='前缀'
                    value={prefix}
                />
                <Input
                    onChange={handleNameChange}
                    placeholder='名称'
                    value={name}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
}

export default OrgInfo